<!-- src/components/GroupCard.svelte -->
<script>
  import { agentStore } from '$lib/stores'

  export let group

  $: activeCount = $agentStore.runs.filter(r => r.group_id === group.id && r.status === 'running').length
  $: totalCount = $agentStore.runs.filter(r => r.group_id === group.id).length

  function handleClick() {
    // Navigate to group detail
  }
</script>

<div class="group-card glass-panel tilt-card" style="--accent: {group.color}" on:click={handleClick}>
  <div class="card-glow"></div>
  <div class="card-header">
    <div class="card-icon" style="background: {group.color}20; color: {group.color}">
      {group.icon}
    </div>
    <div class="card-info">
      <h3 class="card-title">{group.name}</h3>
      <p class="card-desc">{group.description}</p>
    </div>
  </div>
  <div class="card-stats">
    <div class="stat">
      <span class="stat-value">{activeCount}</span>
      <span class="stat-label">active</span>
    </div>
    <div class="stat">
      <span class="stat-value">{totalCount}</span>
      <span class="stat-label">total</span>
    </div>
    <div class="stat">
      <span class="stat-value">{group.max_agents}</span>
      <span class="stat-label">max</span>
    </div>
  </div>
  <div class="card-footer">
    {#if group.modal_fallback}
      <span class="badge modal-badge">Modal</span>
    {/if}
    <span class="status-dot" class:active={activeCount > 0} class:idle={activeCount === 0}></span>
  </div>
</div>

<style>
  .group-card {
    position: relative;
    cursor: pointer;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.08);
    transition: all var(--transition-normal);
  }

  .group-card:hover {
    transform: translateY(-4px);
    border-color: var(--accent);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4), 0 0 20px color-mix(in srgb, var(--accent) 20%, transparent);
  }

  .card-glow {
    position: absolute;
    top: -50%;
    right: -50%;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle, var(--accent) 0%, transparent 70%);
    opacity: 0;
    transition: opacity var(--transition-normal);
    pointer-events: none;
  }

  .group-card:hover .card-glow {
    opacity: 0.08;
  }

  .card-header {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    margin-bottom: 16px;
  }

  .card-icon {
    width: 44px;
    height: 44px;
    border-radius: var(--radius-md);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    flex-shrink: 0;
  }

  .card-info {
    flex: 1;
    min-width: 0;
  }

  .card-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
    text-transform: capitalize;
    margin-bottom: 4px;
  }

  .card-desc {
    font-size: 12px;
    color: var(--text-muted);
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .card-stats {
    display: flex;
    gap: 16px;
    padding: 12px 0;
    border-top: 1px solid var(--glass-border);
    border-bottom: 1px solid var(--glass-border);
    margin-bottom: 12px;
  }

  .stat {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .stat-value {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
  }

  .stat-label {
    font-size: 10px;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .badge {
    font-size: 10px;
    padding: 3px 8px;
    border-radius: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .modal-badge {
    background: rgba(124, 92, 255, 0.15);
    color: var(--accent-primary);
  }
</style>